export { addToFolderEventAction } from 'next-flight-server-reference-proxy-loader?id=4088be073b975c2d8cc86d6301d29c620400ce3d72&name=addToFolderEventAction!'